import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractColorPairInput} from "../abstract-color-pair-input";
import {TranslateService} from "@ngx-translate/core";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditColorPairInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-color-pair-input",
    styleUrls: ["./edit-color-pair-input.component.scss"],
    templateUrl: "./edit-color-pair-input.component.html"
})
export class FUIEditColorPairInputComponent extends FUIAbstractColorPairInput {
    constructor(elementRef: ElementRef,
                eventsService: FUIEventsService,
                translateService: TranslateService,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, eventsService, translateService, changeDetectorRef);
    }
}
